import { initGraphQLTada } from 'gql.tada';

import type { introspection } from '@savvy/constants/generated/graphql-env';

export const graphql = initGraphQLTada<{
  introspection: introspection;
  scalars: {
    BigDecimal: string;
    // Serialized as a string on the wire; accepted as either on input.
    BigInt: string | number;
    ID: string;
    ISO8601Date: string;
    ISO8601DateTime: string;
    JSON: unknown;
    Base64Type: string;
  };
}>();

export type { FragmentOf, ResultOf, VariablesOf, TadaDocumentNode } from 'gql.tada';
export { readFragment as unmaskFragment } from 'gql.tada';
